<style src="./EventResult.scss" lang="scss"></style>
<template>
  <main class="event-result">
    <content-header path="Resultado"/>

    <section class="headercommand">
      <button
        @click="exportSheet"
        class="cp1-small-button command">Copiar Resultado</button>
      <button
        @click="exportSheetToMap"
        class="cp1-small-button command">Copiar para Mapa</button>
      <button
        @click="importModel"
        class="cp1-small-button command">Importar Modelo</button>
      <button
        @click="lostAllItems"
        class="cp1-small-button command">Perdemos todos os items</button>
    </section>

    <is-closed-task
      :stageId="stage._id"
      :eventId="eventId"
      v-model="isStageOpened" />

    <template v-if="isStageOpened">
      <ul class="list-items">
        <list-header
          :winner-list="winnerList"
          :second-list="secondList"
          :third-list="thirdList"
          @select-winner="selectWinner"
          @select-second="selectSecond"
          @select-third="selectThird"
          @select-quoted="showQuoted"
          @select-broad="showBroad" />
        <list-items
          v-for="(item, itemIdx) in filteredItems"
          :key="itemIdx"
          :item="item"
          :itemIdx="itemIdx" />
      </ul>
    </template>

    <modal
      transition="nice-modal-fade"
      name="modalImportModel"
      width="500px"
      height="auto">
      <import-model
        @list-items="listAllItems"
        @finish-upload="finishUpload" />
    </modal>
    <modal
      class="remove-overflow"
      transition="nice-modal-fade"
      name="modalLostAllItems"
      width="500px">
      <lost-all-items
        @close="closeModalLostAllItems" />
    </modal>
  </main>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import ListItems from './components/list-items/ListItems'
import ListHeader from './components/list-header/ListHeader'
import IsClosedTask from '@/components/foundation/is-closed-task/IsClosedTask'
import ImportModel from './components/import-model/ImportModel'
import LostAllItems from './components/lost-all-items/LostAllItems'
import { mapGetters } from 'vuex'
export default {
  name: 'EventResult',
  components: {
    ContentHeader,
    ListItems,
    ListHeader,
    IsClosedTask,
    ImportModel,
    LostAllItems
  },
  data () {
    return {
      isStageOpened: false,
      filteredItems: [],
      filters: {
        winner: '',
        second: '',
        third: '',
        wasQuoted: false,
        isBroad: false
      },
      winnerList: [],
      secondList: [],
      thirdList: []
    }
  },
  computed: {
    stage () {
      return this.$store.getters['Board/STAGE_BY_NAME']('Resultado')
    },
    eventId () {
      return this.$route.params.id
    },
    ...mapGetters({
      items: 'Result/LIST_ITEMS'
    })
  },
  watch: {
    items (list) {
      this.computeFilters(list)
      this.filteredItems = Object.freeze(list)
    },
    isStageOpened (isOpened) {
      if (isOpened) {
        this.listAllItems()
      }
    },
    filters: {
      handler () {
        this.filterResult()
      },
      deep: true
    }
  },
  methods: {
    async listAllItems () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      await this.$store.dispatch('Result/LOAD_EVENT', { eventId })
    },
    computeFilters (items) {
      const winnerList = {}
      const secondList = {}
      const thirdList = {}
      for (const item of items) {
        if (item.result && item.result.winner && item.result.winner.distributor) {
          winnerList[item.result.winner.distributor] = item.winnerDistributor.name
        }
        if (item.result && item.result.second && item.result.second.distributor) {
          secondList[item.result.second.distributor] = item.secondDistributor.name
        }
        if (item.result && item.result.third && item.result.third.distributor) {
          thirdList[item.result.third.distributor] = item.thirdDistributor.name
        }
      }

      this.winnerList = winnerList
      this.secondList = secondList
      this.thirdList = thirdList
    },
    openedTask () {
      this.isOpenedTask = true
    },
    async exportSheetToMap () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      const items = await this.$store.getters['Result/LIST_ITEMS']
      let rankingCol = []
      let rowNumber = 3
      for (const item in items) {
        let rowCSV = []
        if (items[item].result && items[item].result.winner) {
          const winnerOffer = items[item].result.winner.offer

          rowCSV.push(`<td>${winnerOffer.convertToCurrencyBR()}</td>`)
          rowCSV.push(`<td>=I${rowNumber}*A${rowNumber}</td>`)
          rowCSV.push(`<td>${(items[item].winnerDistributor.name && items[item].winnerDistributor.name) || ''}</td>`)
          rowCSV.push(`<td>${items[item].result.winner.lab || ''}</td>`)
        } else {
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
        }

        if (items[item].result && items[item].result.second) {
          const secondOffer = items[item].result.second.offer

          rowCSV.push(`<td>${secondOffer.convertToCurrencyBR()}</td>`)
          rowCSV.push(`<td>=I${rowNumber}*AG${rowNumber}</td>`)
          rowCSV.push(`<td>${(items[item].secondDistributor.name && items[item].secondDistributor.name) || ''}</td>`)
          rowCSV.push(`<td>${items[item].result.second.lab || ''}</td>`)
        } else {
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
        }

        if (items[item].result && items[item].result.third) {
          const thirdOffer = items[item].result.third.offer

          rowCSV.push(`<td>${thirdOffer.convertToCurrencyBR()}</td>`)
          rowCSV.push(`<td>=I${rowNumber}*AE${rowNumber}</td>`)
          rowCSV.push(`<td>${(items[item].thirdDistributor.name && items[item].thirdDistributor.name) || ''}</td>`)
          rowCSV.push(`<td>${items[item].result.third.lab || ''}</td>`)
        } else {
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
          rowCSV.push('<td></td>')
        }
        rankingCol.push('<tr>')
        rankingCol.push(rowCSV.join(''))
        rankingCol.push('</tr>')

        rowNumber++
      }
      const winnerCSV = rankingCol.join('')

      await navigator.permissions.query({
        name: 'clipboard-write'
      })

      const finalTable = `<html><body><table>
        <tr>
          <td>VENCEDOR</td>
          <td></td>
          <td></td>
          <td></td>
          <td>2º LUGAR</td>
          <td></td>
          <td></td>
          <td></td>
          <td>3º LUGAR</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>V.UNIT</td>
          <td>V.TOTAL</td>
          <td>FORNECEDOR</td>
          <td>FABRICANTE</td>
          <td>V.UNIT</td>
          <td>V.TOTAL</td>
          <td>FORNECEDOR</td>
          <td>FABRICANTE</td>
          <td>V.UNIT</td>
          <td>V.TOTAL</td>
          <td>FORNECEDOR</td>
          <td>FABRICANTE</td>
        </tr>
        ${winnerCSV}
      </table></body></html>`
      try {
        document.addEventListener('copy', function (e) {
          e.clipboardData.setData('text/html', finalTable)
          e.preventDefault()
        })
        document.execCommand('copy')
        this.$toasted.success('Resultado copiado')
      } catch (error) {
        return Error(error)
      }
    },
    async exportSheet () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      const items = await this.$store.getters['Result/LIST_ITEMS']
      let rankingCol = []
      let rowNumber = 2
      for (const item in items) {
        let rowCSV = []
        const hasResult = items[item].result

        const hasWinner = hasResult && items[item].result.winner
        const hasSecond = hasResult && items[item].result.second
        const hasThird = hasResult && items[item].result.third

        if (hasWinner) {
          const winnerOffer = items[item].result.winner.offer

          rowCSV.push(`<td>${items[item].itemInfo.lot || ''}</td>`)
          rowCSV.push(`<td>${items[item].itemInfo.number}</td>`)
          rowCSV.push(`<td>${items[item].itemInfo.quantity}</td>`)
          rowCSV.push(`<td>${winnerOffer.convertToCurrencyBR()}</td>`)
          rowCSV.push(`<td>=D${rowNumber}*C${rowNumber}</td>`)
          rowCSV.push(`<td>${(items[item].winnerDistributor.name && items[item].winnerDistributor.name) || ''}</td>`)
          rowCSV.push(`<td>${items[item].result.winner.lab || ''}</td>`)
        }

        if (hasSecond) {
          const secondOffer = items[item].result.second.offer

          rowCSV.push(`<td>${secondOffer.convertToCurrencyBR()}</td>`)
          rowCSV.push(`<td>=H${rowNumber}*C${rowNumber}</td>`)
          rowCSV.push(`<td>${(items[item].secondDistributor.name && items[item].secondDistributor.name) || ''}</td>`)
          rowCSV.push(`<td>${items[item].result.second.lab || ''}</td>`)
        }

        if (hasThird) {
          const thirdOffer = items[item].result.third.offer

          rowCSV.push(`<td>${thirdOffer.convertToCurrencyBR()}</td>`)
          rowCSV.push(`<td>=L${rowNumber}*C${rowNumber}</td>`)
          rowCSV.push(`<td>${(items[item].thirdDistributor.name && items[item].thirdDistributor.name) || ''}</td>`)
          rowCSV.push(`<td>${items[item].result.third.lab || ''}</td>`)
        }

        if (hasWinner || hasSecond || hasThird) {
          rankingCol.push('<tr>')
          rankingCol.push(rowCSV.join(''))
          rankingCol.push('</tr>')
        }

        rowNumber++
      }
      const winnerCSV = rankingCol.join('')

      await navigator.permissions.query({
        name: 'clipboard-write'
      })

      const finalTable = `<html><body><table>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>VENCEDOR</td>
          <td></td>
          <td></td>
          <td></td>
          <td>2º LUGAR</td>
          <td></td>
          <td></td>
          <td></td>
          <td>3º LUGAR</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>LOTE</td>
          <td>N. ITEM</td>
          <td>QT</td>
          <td>V.UNIT</td>
          <td>V.TOTAL</td>
          <td>DISTRIBUIDOR</td>
          <td>LAB</td>
          <td>V.UNIT</td>
          <td>V.TOTAL</td>
          <td>DISTRIBUIDOR</td>
          <td>LAB</td>
          <td>V.UNIT</td>
          <td>V.TOTAL</td>
          <td>DISTRIBUIDOR</td>
          <td>LAB</td>
        </tr>
        ${winnerCSV}
      </table></body></html>`
      try {
        document.addEventListener('copy', function (e) {
          e.clipboardData.setData('text/html', finalTable)
          e.preventDefault()
        })
        document.execCommand('copy')
        this.$toasted.success('Resultado copiado')
      } catch (error) {
        return Error(error)
      }
    },
    selectWinner (v) { this.filters.winner = v },
    selectSecond (v) { this.filters.second = v },
    selectThird (v) { this.filters.third = v },
    showQuoted (v) { this.filters.wasQuoted = v },
    showBroad (v) { this.filters.isBroad = v },
    filterResult () {
      const winnerFilter = this.filters.winner
      const secondFilter = this.filters.second
      const thirdFilter = this.filters.third

      if (winnerFilter.length === 0 &&
        secondFilter.length === 0 &&
        thirdFilter.length === 0 &&
        !this.filters.wasQuoted &&
        !this.filters.isBroad) {
        this.filteredItems = []
        this.$nextTick(() => {
          this.filteredItems = [ ...this.items ]
        })
        return true
      }
      const filteredItems = this.items.filter(i => {
        const winnerName = i.winnerDistributor && i.winnerDistributor.name
        const secondName = i.secondDistributor && i.secondDistributor.name
        const thirdName = i.thirdDistributor && i.thirdDistributor.name

        if (winnerFilter.length > 0 && winnerFilter === winnerName) {
          return true
        }
        if (secondFilter.length > 0 && secondFilter === secondName) {
          return true
        }
        if (thirdFilter.length > 0 && thirdFilter === thirdName) {
          return true
        }
        if (this.filters.wasQuoted && i.itemQuoted.quotePrice > 0) {
          return true
        }
        if (this.filters.isBroad && !(i.itemInfo && i.itemInfo.strictToME === true)) {
          return true
        }

        return false
      })
      this.filteredItems = filteredItems
    },
    importModel () {
      this.$modal.show('modalImportModel')
    },
    finishUpload () {
      this.$modal.hide('modalImportModel')
    },
    lostAllItems () {
      this.$modal.show('modalLostAllItems')
    },
    closeModalLostAllItems () {
      this.$modal.hide('modalLostAllItems')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/event-result/EventResult.vue